var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath305(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.149,
    height: 24.149,
    viewBox: "0 0 24.149 24.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M22.137,0H2.012A2.018,2.018,0,0,0,0,2.012V22.137a2.018,2.018,0,0,0,2.012,2.012H22.137a2.018,2.018,0,0,0,2.012-2.012V2.012A2.018,2.018,0,0,0,22.137,0ZM4.025,21.13H2.012V19.118H4.025Zm0-5.031H2.012V14.087H4.025Zm0-6.037H2.012V8.05H4.025Zm0-5.031H2.012V3.019H4.025ZM18.112,20.124H6.037V13.081H18.112Zm0-9.056H6.037V4.025H18.112ZM22.137,21.13H20.124V19.118h2.012Zm0-5.031H20.124V14.087h2.012Zm0-6.037H20.124V8.05h2.012Zm0-5.031H20.124V3.019h2.012Z",
    fill: "#cecfd0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath305);
export default __webpack_public_path__ + "static/media/Path 305.728bf3f443f9ff7a63e6f6110e926390.svg";
export { ForwardRef as ReactComponent };